module.exports = __webpack_public_path__ + "static/Access_Pay_Day_Logo_Transparent-770795c246a3ccc0aae1d2c22cd9ae9f.png";